var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center"},[_c('img',{staticClass:"zippy-support",attrs:{"src":require("@/assets/img/zolly-hotline.svg"),"alt":""}}),_c('h2',{staticClass:"mt-4"},[_vm._v(" "+_vm._s(_vm.$t('layout.not-found'))+" ")]),_c('router-link',{attrs:{"to":'/'}},[_vm._v(" Retourner à l'accueil")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }